<template>
  <b-container fluid>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Image Templates</h2>
        </b-col>
        <b-col class="float-right">
          <!-- Actions -->
        </b-col>
      </b-row>

      <b-nav>
        <b-nav-item :to="{name: 'image_templates'}" active-class="tab_active">Image Templates</b-nav-item>
      </b-nav>
    </div>

    <b-container>
      <b-alert v-if="profile.team.plan === null" variant="danger" class='text-center' show><strong>Please upgrade</strong> - You cannot add images until you upgrade your plan</b-alert>
    </b-container>

    <keep-alive include="image_template_list">
      <router-view :profile="profile" :user="user"/>
    </keep-alive>
  </b-container>
</template>

<script>
export default {
  props: ['profile', 'user']
}
</script>

<style>

</style>
